import React from 'react';
import { styled } from '@linaria/react';

import HitCounter from '@/components/HitCounter';
import { ContentContext } from '@/components/ContentProvider';

const Demo = ({ hideFooter }) => {
  const { hits } = React.useContext(ContentContext) || {};

  return (
    <Wrapper>
      <ButtonWrapper>
        {typeof hits === 'number' && (
          <HitCounter hits={hits || 12345} />
        )}
      </ButtonWrapper>
      {!hideFooter && (
        <Caption>
          A real live hit counter! Click for a surprise ✨
        </Caption>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ButtonWrapper = styled.div`
  height: 40px;
`;

const Caption = styled.div`
  padding-top: 12px;
  font-size: 14px;
  text-align: center;
`;

export default Demo;
